import React, { FC, useState, useEffect } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { SCUIContent } from '../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SCUIButton } from '../../atomic/atoms';
import { SCUICustomDataGrid, SCUIGeneralDrawer, SCUIBreadCrumb } from '../../atomic/molecules';
import { SCUICargoFilter } from './components';
import { Box, Button, Fade, IconButton, LinearProgress, Menu } from '@mui/material';
import billingInfoImage from '../../../src/assets/icons/svg/pageIcons/billingInfo.svg';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { CargoShipmentFeeManagement, initialState } from './Cargo.helper';
import { Paper, FormControl, MenuItem, InputLabel, Select, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { downloadExcel, readExcelFileAsArray } from '../../utils/excelFileHelper';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { SCUICargoEdit } from './components/SCUICargoEdit/SCUICargoEdit';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { SCUIConfirmDialog } from './components/SCUIConfirmDialog/SCUIConfirmDialog';
import Swal from 'sweetalert2';
import { CargoQuery } from '../../services/query';
import { CargoCommand } from '../../services/command';
import { CSF } from './cargoShippingFeeManagement.classes';
import { buildCargoShipmentFilterData } from './CargoShippingFeeManagement.helper';

export const CargoShippingManagement: FC<any> = () => {
    const [filterInput, setFilterInput] = useState(initialState.cargoFilters);
    const { t } = useTranslation();
    const [datas, setDatas] = React.useState<CargoShipmentFeeManagement[]>();
    const [uploadDatas, setUploadDatas] = React.useState<CargoShipmentFeeManagement[]>();

    const onDrawerFilterOpen = () => setDrawerFilterOpen(true);
    const onDrawerFilterClose = () => setDrawerFilterOpen(false);
    const onDrawerEditOpen = () => setDrawerEditOpen(true);
    const onDrawerEditClose = () => setDrawerEditOpen(false);
    const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
    const [drawerEditOpen, setDrawerEditOpen] = useState(false);
    const [regionList, setRegionList] = React.useState([]);
    const [chipData, setChipData] = React.useState<IChipData[]>([]);
    const chipList: IChipData[] = [];
    const [statusList, setStatusList] = React.useState([]);
    const [selectedCargoItem, setSelectedCargoItem] = useState<any>();
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
    const [actionType, setActionType] = React.useState<'update' | 'delete' | 'fileUpload'>('delete');
    const [dialogTitle, setDialogTitle] = React.useState<string>('');
    const [dialogContent, setDialogContent] = React.useState<string>('');
    const [cargoNameList, setCargoNameList] = React.useState([]);
    const [deliveryTypeList, setDeliveryTypeList] = React.useState([]);
    const hiddenFileInput = React.useRef<any>(null);
    const [loading, setLoading] = React.useState<any>(false);
    const selectedCountry = localStorage.getItem('selectedCountry');
    const countryId = selectedCountry ? JSON.parse(selectedCountry)?.countryId : undefined;

    interface IChipData {
        key: number;
        label: string;
    }
    const ListItem = styled('li')(({ theme }) => ({
        margin: theme.spacing(0.5),
    }));

    useEffect(() => {
        GetRegionList();
        GetStatusList();
    }, []);

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };
    const handleClickOpenConfirmDialog = (
        selectedRow: any,
        uploadDatas: CargoShipmentFeeManagement[],
        actionType: 'update' | 'delete' | 'fileUpload',
        dialogTitle: string,
        dialogContent: string
    ) => {
        SetCargoItem(selectedRow);
        setActionType(actionType);
        setDialogTitle(dialogTitle);
        setDialogContent(dialogContent);
        setUploadDatas(uploadDatas);
        setOpenConfirmDialog(true);
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'id',
            headerName: 'id',
            flex: 1,
            hideable: true,
            renderCell: (params: any) => (
                <span className={CSF.cellId} data-id={params.row.id}>
                    {params.row.id}
                </span>
            ),
        },
        {
            field: 'status',
            headerName: t('general.status'),
            flex: 1,
            editable: false,
            disableColumnMenu: true,
            renderCell: (cellInfo) => (
                <div className={CSF.cellStatus}>
                    <Switch
                        className={CSF.inputCellStatusSwitch}
                        data-id={cellInfo.row.id}
                        data-status={String(!!cellInfo.row.status)}
                        checked={cellInfo.row.status}
                        disabled
                    />
                </div>
            ),
        },
        {
            field: 'region',
            headerName: t('general.region'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={CSF.cellRegion} data-id={params.row.id} data-region={params.row.region}>
                    {params.row.region}
                </span>
            ),
        },
        {
            field: 'cargoCompany',
            headerName: t('general.cargoCompany'),
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={CSF.cellCargoCompany}
                    data-id={params.row.id}
                    data-cargo-company={params.row.cargoCompany}
                >
                    {params.row.cargoCompany}
                </span>
            ),
        },
        {
            field: 'deliveryType',
            headerName: t('general.deliveryType'),
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={CSF.cellDeliveryType}
                    data-id={params.row.id}
                    data-delivery-type={params.row.deliveryType}
                >
                    {params.row.deliveryType}
                </span>
            ),
        },
        {
            field: 'shoppingAmount',
            headerName: t('general.shoppingAmount'),
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={CSF.cellShoppingAmount}
                    data-id={params.row.id}
                    data-shopping-amount={params.row.shoppingAmount}
                >
                    {params.row.shoppingAmount}
                </span>
            ),
        },
        {
            field: 'shipmentFee',
            headerName: t('general.shipmentFee'),
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={CSF.cellShipmentFee}
                    data-id={params.row.id}
                    data-shipment-fee={params.row.shipmentFee}
                >
                    {params.row.shipmentFee}
                </span>
            ),
        },
        {
            field: 'condition',
            headerName: t('general.condition'),
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={CSF.cellCondition}
                    data-id={params.row.id}
                    data-condition={params.row.condition}
                >
                    {params.row.condition}
                </span>
            ),
        },
        {
            field: 'ruleTemplateId',
            headerName: 'ruleTemplateId',
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={CSF.cellRuleTemplateId}
                    data-id={params.row.id}
                    data-rule-template-id={params.row.ruleTemplateId}
                >
                    {params.row.ruleTemplateId}
                </span>
            ),
        },
        {
            field: 'actions ',
            headerName: t('general.actions'),
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => {
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <div className={CSF.cellActions}>
                                <IconButton
                                    {...bindTrigger(popupState)}
                                    className={CSF.btnRowMenu}
                                    data-id={params.row.id}
                                >
                                    <MoreVertIcon className="svg_icons" />
                                </IconButton>
                                <Menu {...bindMenu(popupState)} className={CSF.rowMenu}>
                                    <MenuItem
                                        onClick={() => onDrawerModalEditOpen(params.row)}
                                        className={`${CSF.rowMenuItem} ${CSF.rowMenuItemEdit}`}
                                        data-action="edit"
                                        data-id={params.row.id}
                                    >
                                        {t('general.edit')}
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() =>
                                            handleClickOpenConfirmDialog(
                                                params.row,
                                                [],
                                                'delete',
                                                '',
                                                t('general.deleteConfirmationText')
                                            )
                                        }
                                        className={`${CSF.rowMenuItem} ${CSF.rowMenuItemDelete}`}
                                        data-action="delete"
                                        data-id={params.row.id}
                                    >
                                        {t('general.delete')}
                                    </MenuItem>
                                </Menu>
                            </div>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const getCargoShipmentList = async (filterInput?: any) => {
        try {
            if (!loading) {
                setLoading(true);
                if (!filterInput || filterInput.region === -1) {
                    Swal.fire('Error', t('general.selectRegion'), 'error');
                    return;
                }
                let { filterData, criterias } = buildCargoShipmentFilterData(filterInput);

                if (filterInput.shoppingAmount !== null) {
                    const isNumeric =
                        typeof filterInput.shoppingAmount === 'number' && !Number.isNaN(filterInput.shoppingAmount);

                    if (isNumeric) {
                        criterias.shoppingAmount = filterInput.shoppingAmount.toString();
                    } else {
                        Swal.fire('Error', t('general.checkShipmentFee'), 'error');
                        return;
                    }
                }
                if (filterInput.ruleTemplateId != null) {
                    filterData.ruleTemplateId = filterInput.ruleTemplateId;
                }

                filterData.criteriaFilter = Object.keys(criterias).length === 0 ? {} : criterias;
                onDrawerFilterClose();

                let response: any = await CargoCommand.GetShippingFeeManagementListByFilter(filterData);
                if (response.isSuccess) {
                    if (response && response.data && response.data.data && response.data.data.length > 0) {
                        let parseData = response.data.data.map((item: any) => {
                            let cargoCompany: any = item.criteria.find(
                                (c: any) => c.key === 'ShippingCompanyId'
                            )?.value;

                            let region: any = item.criteria.find((c: any) => c.key?.toLowerCase() === 'region')?.value;
                            let deliveryType: any = item.criteria.find((c: any) => c.key === 'DeliveryType')?.value;
                            let shipmentFee: any = Number(item.action);
                            let shoppingAmount: any = item.criteria.find((c: any) => c.key === 'shoppingAmount');
                            let ruleTemplateIdValue: any = item.ruleTemplateId;

                            let shoppingAmountValue: number = 0;
                            let today: Date = new Date();

                            let statusValue: boolean =
                                today >= new Date(item.effectiveDate) && today < new Date(item.endDate);

                            let conditionValue: string = '';
                            if (shoppingAmount?.operator == 3) {
                                if (shoppingAmount?.value.includes('#')) {
                                    if (shoppingAmount.value.endsWith('#')) {
                                        // "4000#" formatı - >= 4000
                                        conditionValue = '>=';
                                        shoppingAmountValue = Number(shoppingAmount.value.replace('#', ''));
                                    } else {
                                        // "0#4000" formatı - < 4000
                                        const parts = shoppingAmount.value.split('#');
                                        if (parts.length === 2) {
                                            conditionValue = '<';
                                            shoppingAmountValue = Number(parts[1]); // Üst limit
                                        }
                                    }
                                }
                            }
                            return {
                                id: item.id,
                                status: statusValue,
                                region: region,
                                cargoCompany: cargoCompany,
                                deliveryType: deliveryType,
                                shoppingAmount: shoppingAmountValue,
                                shipmentFee: Number(shipmentFee),
                                condition: conditionValue,
                                ruleTemplateId: ruleTemplateIdValue,
                            };
                        });
                        setDatas(parseData);
                    } else {
                        Swal.fire('Error', t('general.noDataFound'), 'error');
                        setDatas([]);
                    }
                } else {
                    Swal.fire('Error', response.errorMessage, 'error');
                }
                setLoading(false);
            }
        } catch (error: any) {
            Swal.fire(error?.data?.Message, error?.data?.Key, 'error');
            setLoading(false);
        }
    };
    const exportExcel = () => {
        let data: any = [];
        data = datas;
        data.forEach((element: any) => {
            element.status = element.status ? 1 : 0;
        });
        downloadExcel({
            excelDownloadData: data,
            excelDownloadFolderName: 'CargoShippingManagementList',
        });
    };
    const importExcel = (e: any) => {
        const files = e.target.files;
        if (files && files[0]) {
            handleFile(files[0]);
        }
    };
    const handleClick = () => {
        hiddenFileInput.current.click();
    };

    const excelDataToCargoShipmentList = (excelDatas: any[]) => {
        let datas: any[] = [];
        try {
            excelDatas = excelDatas.filter(function (el) {
                return el != null;
            });

            if (excelDatas) {
                for (let i = 1; i < excelDatas.length; i++) {
                    let itemStatus = excelDatas[i][2] == 1;
                    let item: any = {
                        enabled: itemStatus,
                        regionId: excelDatas[i][3],
                        cargoCompanyId: excelDatas[i][4],
                        deliveryTypeId: excelDatas[i][5],
                        shoppingAmount: excelDatas[i][6],
                        shipmentFee: excelDatas[i][7],
                        condition: excelDatas[i][8],
                        ruleTemplateId: excelDatas[i][9],
                    };
                    let isValidData: boolean = true;

                    /*Boş satırlar için kontrol*/
                    if (
                        item.cargoCompanyId === undefined &&
                        item.regionId === undefined &&
                        item.deliveryTypeId === undefined &&
                        item.condition === undefined &&
                        item.shoppingAmount === undefined &&
                        item.shipmentFee == undefined
                    ) {
                        isValidData = false;
                    } else if (
                        item.cargoCompanyId === undefined ||
                        item.regionId === undefined ||
                        item.deliveryTypeId === undefined ||
                        item.condition === undefined ||
                        item.shoppingAmount === undefined ||
                        item.shipmentFee == undefined
                    ) {
                        Swal.fire('Error', t('general.checkExcelData'), 'error');
                        return;
                    }

                    if (isValidData && item?.regionId > 0 && item?.cargoCompanyId > 0 && item?.deliveryTypeId > 0) {
                        datas.push(item);
                    }
                }
                handleClickOpenConfirmDialog(
                    selectedCargoItem,
                    datas,
                    'fileUpload',
                    t('general.uploadFile'),
                    t('general.fileUploadText')
                );
            }
        } catch (err: any) {
            Swal.fire('Error', err.toString(), 'error');
        }
    };
    const handleFile = async (file: File) => {
        const data = await readExcelFileAsArray(file);
        if (data) {
            excelDataToCargoShipmentList(data);
        }
    };

    const onDrawerModalEditOpen = (row: any) => {
        SetCargoItem(row);
        onDrawerEditOpen();
    };

    const SetCargoItem = (item: any) => {
        try {
            let cargoItem: any = item;
            setSelectedCargoItem(cargoItem);
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetCargoList = async (regionId: number) => {
        try {
            if (regionId === -1) {
                Swal.fire('Error', t('general.selectRegion'), 'error');
                return;
            }
            let response: any = await CargoQuery.GetSelectedItemList({
                RequestType: 1,
                AddressEntityRegionId: regionId,
                CountryId: countryId,
            });
            if (response.isSuccess) {
                setCargoNameList(response?.addressEntities);
            } else {
                Swal.fire(
                    'Service Error - StatusCode : ' + response.statusCode,
                    'Error Message : ' + response.errorMessage,
                    'error'
                );
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetDeliveryTypeList = async (regionId: number, cargoCompanyId: number) => {
        try {
            if (regionId === -1 || cargoCompanyId === 0) {
                Swal.fire('Error', t('general.selectCargo'), 'error');
                return;
            }

            let response: any = await CargoQuery.GetSelectedItemList({
                RequestType: 2,
                AddressEntityRegionId: regionId,
                CountryId: countryId,
                ShippingCompanyId: cargoCompanyId,
            });
            if (response.isSuccess) {
                setDeliveryTypeList(response?.addressEntities);
            } else {
                Swal.fire(
                    'Service Error - StatusCode : ' + response.statusCode,
                    'Error Message : ' + response.errorMessage,
                    'error'
                );
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetRegionList = async () => {
        try {
            let response: any = await CargoQuery.GetSelectedItemList({
                RequestType: 0,
                CountryId: countryId,
            });
            if (response.isSuccess) {
                setRegionList(response?.addressEntities);
            } else {
                Swal.fire(
                    'Service Error - StatusCode : ' + response.statusCode,
                    'Error Message : ' + response.errorMessage,
                    'error'
                );
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    const GetStatusList = () => {
        try {
            let statusList: any = {
                data: [
                    { id: 2, name: 'All' },
                    { id: 1, name: 'Active' },
                    { id: 0, name: 'Passive' },
                ],
            };
            setStatusList(statusList.data);
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };

    return (
        <SCUIContent className={CSF.page}>
            <Box className={CSF.root}>
                <SCUIConfirmDialog
                    open={openConfirmDialog}
                    onClose={handleCloseConfirmDialog}
                    selectedRow={selectedCargoItem?.id}
                    dialogContent={dialogContent}
                    dialogTitle={dialogTitle}
                    buttonNameAccept={t('general.yes')}
                    buttonNameReject={t('general.no')}
                    actionType={actionType!}
                    setDatas={setDatas}
                    datas={datas}
                    uploadDatas={uploadDatas!}
                    setUploadDatas={setUploadDatas}
                    filterInput={filterInput}
                    getCargoShipmentList={getCargoShipmentList}
                ></SCUIConfirmDialog>
                <Box className={CSF.editDrawer}>
                    <SCUIGeneralDrawer
                        open={drawerEditOpen}
                        width={'400px'}
                        onClose={(event: any, reason: any) => {
                            if (reason === 'backdropClick') {
                                setDrawerEditOpen(false);
                            }
                        }}
                    >
                        <SCUICargoEdit
                            selectedRow={selectedCargoItem}
                            onClose={onDrawerEditClose}
                            datas={datas}
                            setDatas={setDatas}
                        />
                    </SCUIGeneralDrawer>
                </Box>

                <Box className={CSF.filterDrawer}>
                    <SCUIGeneralDrawer
                        open={drawerFilterOpen}
                        width={'400px'}
                        onClose={(event: any, reason: any) => {
                            if (reason === 'backdropClick') {
                                setDrawerFilterOpen(false);
                            }
                        }}
                    >
                        <SCUICargoFilter
                            regionList={regionList}
                            statusList={statusList}
                            cargoShipmentList={getCargoShipmentList}
                            onClose={onDrawerFilterClose}
                            filterInput={filterInput}
                            chipList={chipList}
                            cargoNameList={cargoNameList}
                            getCargoList={GetCargoList}
                            deliveryTypeList={deliveryTypeList}
                            getDeliveryTypeList={GetDeliveryTypeList}
                        />
                    </SCUIGeneralDrawer>
                </Box>
                <Grid container direction="row" spacing={2} className={CSF.breadcrumb}>
                    <SCUIBreadCrumb title={t('dashboard.cargoOptimization')} componentLink={'cargoOptimization'} />
                </Grid>
                <Box className={CSF.loading}>
                    <Fade in={loading} unmountOnExit>
                        <LinearProgress />
                    </Fade>
                </Box>
                {datas ? (
                    <Grid container direction="row" spacing={2} className={CSF.body}>
                        <Grid size={{ sm: 11, md: 11, lg: 11, xl: 11 }} className={CSF.subheaderBox}>
                            <p className={`subheadtxt ${CSF.subheader}`}>{t('dashboard.cargoOptimization')}</p>
                        </Grid>

                        <Grid size={{ sm: 7, md: 7, lg: 7, xl: 7 }} className={CSF.toolbarSpacer}></Grid>

                        <Grid size={{ sm: 5, md: 5, lg: 5, xl: 5 }} className={CSF.toolbarActions}>
                            <IconButton
                                className={CSF.btnOpenFilter}
                                sx={{
                                    float: 'right',
                                    width: 40,
                                    height: 40,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    marginRight: 1,
                                }}
                                onClick={() => onDrawerFilterOpen()}
                            >
                                <FilterAltIcon className="svg_icons" sx={{ color: 'primary.main' }} />
                            </IconButton>
                            <IconButton
                                className={CSF.btnExportExcel}
                                sx={{
                                    float: 'right',
                                    width: 100,
                                    height: 40,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    marginRight: 1,
                                }}
                                onClick={exportExcel}
                            >
                                <Button>
                                    <FileDownloadIcon className="svg_icons" sx={{ color: 'primary.main' }} />
                                    {t('general.exportToExcel')}
                                </Button>
                            </IconButton>
                            <IconButton
                                className={CSF.btnImportExcel}
                                sx={{
                                    float: 'right',
                                    width: 100,
                                    height: 40,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    marginRight: 1,
                                }}
                                onClick={importExcel}
                            >
                                <Button onClick={handleClick} className={CSF.btnImportTrigger}>
                                    <FileUploadIcon className="svg_icons" sx={{ color: 'primary.main' }} />
                                    {t('general.uploadFile')}
                                </Button>
                                <input
                                    className={CSF.inputImportFile}
                                    type="file"
                                    ref={hiddenFileInput}
                                    onChange={importExcel}
                                    style={{ display: 'none' }}
                                />
                            </IconButton>
                        </Grid>
                        <Grid size={{ sm: 12, md: 12, lg: 12, xl: 12 }} className={CSF.chipsBox}>
                            {chipList && chipList.length > 0 ? (
                                <Paper
                                    className={CSF.chipsPaper}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap',
                                        float: 'left',
                                        listStyle: 'none',
                                        p: 0.5,
                                        m: 0,
                                    }}
                                    component="ul"
                                >
                                    {chipList.map((data) => {
                                        let icon;

                                        // if (data.label === "React") {
                                        //   icon = <TagFacesIcon />;
                                        // }
                                        if (!data.label.includes('All')) {
                                            return (
                                                <ListItem
                                                    key={data.key}
                                                    className={CSF.chipItem}
                                                    data-chip-key={data.key}
                                                    data-chip-label={data.label}
                                                >
                                                    <Chip
                                                        icon={icon}
                                                        label={data.label}
                                                        className={CSF.chip}
                                                        data-chip-label={data.label}
                                                    />
                                                </ListItem>
                                            );
                                        }
                                    })}
                                </Paper>
                            ) : (
                                <div style={{ display: 'none' }}></div>
                            )}
                        </Grid>

                        <Grid size={{ sm: 12, md: 12, lg: 12, xl: 12 }} className={CSF.grid}>
                            <SCUICustomDataGrid randomId rows={datas} columns={columns} />
                        </Grid>
                    </Grid>
                ) : (
                    <div className={CSF.emptyState}>
                        <div
                            className={CSF.emptyInfo}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <img src={billingInfoImage} className={`centeredImg ${CSF.emptyImage}`} />
                            <p
                                className={CSF.emptyText}
                                style={{
                                    textAlign: 'center',
                                    marginTop: '3rem',
                                    maxWidth: '450px',
                                }}
                            >
                                {t('cargoServiceLog.noRecordText')}
                            </p>
                        </div>

                        <div
                            className={CSF.emptyForm}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignContent: 'center',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <FormControl className={CSF.emptyRegionField} style={{ width: 450, margin: '20px' }}>
                                <InputLabel id="labelRegion">{t('general.selectRegion')}</InputLabel>
                                <Select
                                    className={CSF.inputEmptyRegion}
                                    label={t('general.selectRegion')}
                                    labelId="labelRegion"
                                    id="parentMenuLabel"
                                    onChange={(event) => {
                                        GetCargoList(Number(event.target.value));
                                        GetDeliveryTypeList(Number(event.target.value), -100);
                                        setFilterInput({
                                            ...filterInput,
                                            region: Number(event.target.value),
                                        });
                                        let isChange = false;
                                        let region: any = regionList?.find(
                                            (s: any) => s?.addressEntityId === Number(event.target.value)
                                        );
                                        let regionName = 'Region : '.concat(region?.name);
                                        chipData.find((s: any) => {
                                            if (s?.label?.includes('Region')) {
                                                s.label = regionName;
                                                isChange = true;
                                            }
                                        });
                                        if (!isChange) {
                                            chipData.push({
                                                key: chipData.length + 1,
                                                label: regionName,
                                            });
                                        }
                                        setChipData(chipData);
                                    }}
                                >
                                    {regionList &&
                                        regionList.map((region: any) => (
                                            <MenuItem
                                                key={region.addressEntityId}
                                                id={region.addressEntityId}
                                                value={region.addressEntityId}
                                                className={CSF.regionMenuItem}
                                                data-region-id={region.addressEntityId}
                                                data-region-name={region.name}
                                            >
                                                {region.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                            <FormControl className={CSF.emptyFilterAction} style={{ width: 450, margin: '10px' }}>
                                <SCUIButton
                                    className={CSF.btnEmptyFilter}
                                    text={t('general.filter')}
                                    type="primary"
                                    sizeType="default"
                                    size={'l'}
                                    onClick={() => getCargoShipmentList(filterInput)}
                                />
                            </FormControl>
                            <FormControl className={CSF.emptyDetailedAction} style={{ width: 450 }}>
                                <SCUIButton
                                    className={CSF.btnEmptyDetailed}
                                    text={t('general.detailedFiltering')}
                                    type="secondary"
                                    sizeType="default"
                                    size={'l'}
                                    onClick={() => onDrawerFilterOpen()}
                                />
                            </FormControl>
                        </div>
                    </div>
                )}
            </Box>
        </SCUIContent>
    );
};
